import React, { ReactElement } from 'react';
import { Container } from '@sm/wds-react';

import { HeaderTypeEnum, HeaderImagePropsType } from '../../types';

import PremiumLogo from './Premium';
import StandardLogo from './Standard';

const Logo = (props: HeaderImagePropsType) => {
  const { headerType, url, altText } = props;
  if (url) {
    return (
      <Container className="sm-enterprise-thank-you__header-logo" flex flexJustify="center">
        {headerType === HeaderTypeEnum.PREMIUM ? (
          <PremiumLogo url={url} altText={altText} />
        ) : (
          <StandardLogo url={url} altText={altText} />
        )}
      </Container>
    );
  }
  return null;
};

export default Logo;
